<template>
  <div class="turnaround-analysis-main">
    <!--Left Section-->
    <div class="left-container">
      <div class="separator"></div>
      <div class="date-section">
        <div style="flex-grow: 1;">
          <span>Movement Date</span>
          <DateTimePicker title="From" placeholder="From" :showTime="false" :value.sync="fromDate" />
          <DateTimePicker title="To" placeholder="To" :showTime="false" :value.sync="toDate" />
        </div>
      </div>
      <div class="button-section">
        <button @click="refreshClicked">Refresh</button>
      </div>
      <div class="filter-table">
        <Filters class="destcode-filter" title="Geofenced Destination" :tableData="destcodeData"
          itemKey="Destination Code" itemDesc="DestinationCode" @confirmClicked="filterDestCodeConfirm"
          :selectedObject.sync="selectedDestination" />
      </div>
    </div>
    <!-- Right Section -->
    <div class="right-container">
      <!-- Top bar showing filter selections -->
      <div class="filtered-section">
        <div class="filtered-items">
          <div class="filtered-row">
            <div class="filter-title-long">Movement Date</div>
            <div class="colon-separator">:</div>
            <div class="filter-details">
              {{ this.fromDateInfo ? this.fromDateInfo : 'Start Date' }} to {{ this.toDateInfo ? this.toDateInfo : 'End Date' }}
            </div>
          </div>
          <div class="filtered-row">
            <div class="filter-title-long">Geofenced Destination</div>
            <div class="colon-separator">:</div>
            <div class="filter-details">
              {{
                this.selectedDestination == ""
                ? "All"
                : this.selectedDestinationPost.toString()
              }}
            </div>
          </div>
        </div>
        <div class="refresh-section">
          <div>Last Refreshed : {{ refreshDate }}</div>
        </div>
      </div>

      <div v-if="showChart" class="chart-section">
        <div class="chart-row" v-for="(destination,index) in destinationData" :key="index">
          <div class="chart-row-title">Destination Code : {{ destination.destCode }}</div>
          <div class="chart-container">
            <div class="col-left">
              <div class="TAchart TA-BarChart">
                <div class="chart-Title">Total Waiting Time (Over Months)
                  <img class="interactable-chart-indicator" src="https://dsmapi.logistics.systems/dsm6gicons/clickable.png" />
                </div>
                <div class="chart-Container">
                  <div class="bar-chart-HMS-TT" id="bar-chart-HMS-TT" >
                    <BarLineChart v-if="renderChart"  :data="destination.barchartData" :colors="chartColors" :contextMenus="['Monthly Turnaround Details']" @contextMenuClicked="drillThroughClicked" />
                  </div>
                </div>
              </div>

              <div class="col-bot">
                <div class="TAchart TA-PieChart botItem">
                  <div class="chart-Title">Total Waiting Time (based on Vehicle)</div>
                  <div class="chart-Container">
                    <div class="pie-chart-HMS-TT" id="pie-chart-HMS-TT">
                      <PieChart v-if="renderChart" pieID="contPie" :pie-data="destination.piechartData" :colors="chartColors"  refs="contPie" class="contPie"  />
                    </div>
                  </div>
                </div>

                <div class="TAchart TA-StatsTable botItem">
                  <div class="chart-Title">Average Turnaround Time </div>
                  <div class="chart-Container">
                    <div class="TA-table">
                      <table border="2" class="details-table" >
                        <thead>
                          <tr>
                            <th>Waiting Time</th>
                            <th colspan="2">Total Haulage <br>({{fromDateInfo}} to {{toDateInfo}})</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="data in destination.tableData[0]" :key="data.id">
                          <th>{{ data.name }}</th>
                          <td>{{ data.col1 }}</td>
                          <td>{{ data.col2 }}%</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div  v-if="renderMap" class="col-right">
              <div class="TAchart TA-GeoMap">
                <div class="chart-Title">Geofence Location </div>
                <div class="chart-Container">
                  <BoxContainer class="mapItem Item1" title="Address Summary">
                      <div style="font-weight: bold">{{ destination.addressSum[0]['companyName'] || "--" }}</div>
                      <div>{{ destination.addressSum[0]['addressLine1'] || '--' }}</div>
                      <div>{{ destination.addressSum[0]['addressLine2'] || '--' }}</div>
                      <div>{{ destination.addressSum[0]['addressLine3'] || '--' }}</div>
                      <div>{{ destination.addressSum[0]['addressLine4'] || '--' }}</div>              
                      <div>{{ destination.addressSum[0]['postcode'] || '--' }}, {{ destination.addressSum[0]['city'] || '--' }}</div>
                      <div>{{ destination.addressSum[0]['state'] || '--'}}, {{  destination.addressSum[0]['country'] || '--' }}</div>                   
                    </BoxContainer>
                  <CustomMap v-if="renderMap" class="mapItem Item2" ref="customMap"  style="width:700px;height: 250px;"   :hideSlot="true" :slotFloat="true" :openMenu.sync="openMapMenu" :maxMarkerCount="1" :markers.sync="destination.geofenceData" 
                    :viewMode= "true" >
                  </CustomMap>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>
<script>
/* eslint-disable */
export default {
  components: {},
  data: function () {
    return {
      fromDate: new Date( // first day of past 3 month
        new Date(new Date().setMonth(new Date().getMonth() - 2)).getFullYear(), 
        new Date().getMonth() - 2, 
        1
      ),
      toDate: new Date( // last day of current month
        new Date().getFullYear(),
        new Date().getMonth() + 1,
        0
      ),
      refreshDate: "",
      destcodeData: [],
      selectedDestination: [],
      selectedDestinationPost: [],
      destinationMarkers: [],
      openMapMenu: false,
      fromDateInfo: "-",
      toDateInfo: "-",
      displayDestination: "All",

      destinationData: [],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      chartColors: [ '#ffd246','#28b4c8','#49ff2f','#ff6358'],  
      showChart: false,
      viewMode: false,
      renderChart:false,
      renderMap:false,
    };
  },
  props: {},
  methods: {
    filterDestCodeConfirm: function (items) {
      this.selectedDestination = items;
      this.selectedDestinationPost = items.map((a) => {
        return a["Destination Code"]
      })
    },
    refreshClicked: async function () {
      this.refreshDate = (new Date()).formatString('dd/MM/yyyy HH:mm');
      this.fromDateInfo = this.fromDate ? this.$dateTime.getDateTime(this.fromDate, "yyyy-MM-dd") : "-";
      this.toDateInfo = this.toDate ? this.$dateTime.getDateTime(this.toDate, "yyyy-MM-dd") : "-";
      if (this.fromDate == null || this.toDate == null) {
        this.$showAlert('warning', 'Date range not selected.', 'Please select start date and end date.')
      };
      this.getEachData();
      this.showChart = true;
    },
    getEachData: async function(){
      this.destinationData = [];
      if (this.selectedDestination.length >= 1) {
        this.$fullscreenLoading("Getting Turnaround Analysis");
        const destinationDataPromises = this.selectedDestinationPost.map(async (m) => {
          return {
            destCode: m,
            barchartData: await this.generateBarChart(m),
            piechartData: await this.generatePieChart(m),
            tableData: await this.generateTableData(m),
            addressSum: await this.getAddressSum(m),
            geofenceData: await this.mapViewClicked(m)
          };
        });
        this.destinationData = await Promise.all(destinationDataPromises);
        this.showChart = true;
      }
      else{
        this.$fullscreenLoading("Getting Turnaround Analysis");
        this.renderMap = false;
        const destinationDataPromises = [
          {
            destCode: "All",
            barchartData: await this.generateBarChart(null),
            piechartData: await this.generatePieChart(null),
            tableData: await this.generateTableData(null),
            // addressSum: await this.getAddressSum()
            // geofenceData: await this.mapViewClicked()
          }];
          this.destinationData = await Promise.all(destinationDataPromises);
          this.showChart = true;
      }
    },
    generateBarChart: async function(destcode){
      let dataToPost1 = 
        {
          startdate: this.fromDateInfo,
          enddate: this.toDateInfo,
          rpttype: "byMonth",
          destcode: destcode
        };
      
      let monthly = await this.$apiCallV2( "/TurnaroundAnalysis/GetTurnaroundAnalysis", dataToPost1);
     
      this.$fullscreenLoading();
      let byMonth = [];
      let values = [];
      monthly.forEach((c) => {
        values = [];
        values.push({
          name: "<60 min",
          value: c["b60"],
          type: "bar",
        });
        values.push({
          name: "<30 min",
          value: c["b30"],
          type: "bar",
        });
        values.push({
          name: "<45 min",
          value: c["b45"],
          type: "bar",
        });
        values.push({
          name: ">60 min",
          value: c["a60"],
          type: "bar",
        });
        byMonth.push({
          name: `${c["currentYear"]} ${this.months[c["currentMonth"] - 1]} (${c["DestinationCode"]})`,
          value: values,
        });
      });
        return byMonth
    },
    generatePieChart: async function(destcode){
        let dataToPost2 =
        {
          startdate : this.fromDateInfo,
          enddate : this.toDateInfo,
          rpttype : "byVehicleNo",
          destcode : destcode,
        };

        let byVehicle =[{name:"<30 min", value:null},
        {name:"<45 min", value:null, },
        {name:"<60 min", value:null},
        {name:">60 min", value:null}];

        var VehNoData = await this.$apiCallV2("/TurnaroundAnalysis/GetTurnaroundAnalysis", dataToPost2);
        VehNoData.forEach((c) => 
        {
          byVehicle.forEach(v => 
          {
            if(v.name === "<30 min"){
              v.value = c["below30"];
            }else if (v.name === "<45 min"){
              v.value = c["below45"];
            }else if (v.name === "<60 min"){
              v.value = c["below60"];
            }else if (v.name === ">60 min"){
              v.value = c["above60"];
            }
          })
        });
        this.renderChart = true;
        return byVehicle
    },
    generateTableData: async function(destcode){
        let dataToPost3 = 
        {
          startdate: this.fromDateInfo,
          enddate: this.toDateInfo,
          rpttype: "byDestCode",
          destcode: destcode
        };
        let tabData =[];
        var tableData = await this.$apiCallV2( "/TurnaroundAnalysis/GetTurnaroundAnalysis", dataToPost3);
        let value2 = [];
          tableData.forEach((c) => {
            value2= [];
            value2.push({
              id:1,
              name: "<30min",
              col1: c["below30"],
              col2: ((c["below30"] / (c["below30"] + c["below45"] + c["below60"] + c["above60"]))*100).toFixed(2),
            });
            value2.push({
              id:2,
              name: "<45min",
              col1: c["below45"],
              col2: ((c["below45"] / (c["below30"] + c["below45"] + c["below60"] + c["above60"]))*100).toFixed(2),
            });
            value2.push({
              id:3,
              name: "<60min",
              col1: c["below60"],
              col2: ((c["below60"] / (c["below30"] + c["below45"] + c["below60"] + c["above60"]))*100).toFixed(2),
            });
            value2.push({
              id:4,
              name: ">60min",
              col1: c["above60"],
              col2: ((c["above60"] / (c["below30"] + c["below45"] + c["below60"] + c["above60"]))*100).toFixed(2),
            });
            value2.push({
              id:5,
              name: "Total",
              col1: c["below30"] + c["below45"] + c["below60"] + c["above60"],
              col2: "100"
            });
            tabData.push(value2);
          });
          return tabData
    },
    getAddressSum: async function(destcode){
      let addressSum = [];
      let details = this.$jsonNullToStringV2(this.$deepTrimJsonV3((await this.$apiCallV2('/Master/GetDetailsMaster', {masterfile:'destination', module:'MASTER', recordid: destcode}))['Destination']));
      if (destcode != null){
        addressSum.push({
          companyName : details['Company'],
          addressLine1 : details['Addr1'],
          addressLine2 : details['Addr2'],
          addressLine3 : details['Addr3'],
          addressLine4 : details['Addr4'],
          postcode : details['PostCode'],
          city : details['City'],
          state : details['State'],
          country : details['Country']
        })
      };
      return addressSum
    },
    mapViewClicked: async function(destcode){
      let destinationMarkers = [];
      let details = this.$jsonNullToStringV2(this.$deepTrimJsonV3((await this.$apiCallV2('/Master/GetDetailsMaster', {masterfile:'destination', module:'MASTER', recordid: destcode}))['Destination']));
      this.viewMode = true;  

     if (!details['Latitude'] || !details['Longtitude']) {
				destinationMarkers = [];
			} else {
				destinationMarkers.push({
					position: {
						lat: parseFloat(details['Latitude']),
						lng: parseFloat(details['Longtitude'])
					},
					geofence: details['Geofence'] ? details['Geofence'].map(g => { return { lat: parseFloat(g['gfLat']), lng: parseFloat(g['gfLon']) } }) : null
				});
			}
      this.renderMap = true;
      return destinationMarkers

    },
    drillThroughClicked: async function(item) {
      if (item.includes("Monthly Turnaround Details")) {
        item = "Turnaround Details Over Month";
        sessionStorage.setItem(
          `Drill Through - DETAILS ${item}`,
          JSON.stringify({
            startdate: this.fromDateInfo,
            enddate: this.toDateInfo,
            rpttype: "By_TAdrillthrough",
            destcode: null,
            refreshDate: this.refreshDate,
            title: item,
          }));

          var drillThroughLink = this.$router.resolve(
            `/Home/${
              this.$route["params"]["user"]
            }/Dashboard/Turnaround Analysis/Drill Through - DETAILS ${item}`
          );
          window.open(drillThroughLink.href, "_blank");
          sessionStorage.clear();
      }
    },
  },
  async mounted() {
    this.$fullscreenLoading("Getting Details");
    this.destcodeData = await this.$apiCallV2(
      '/Master/GetListMaster', { masterfile: 'destination', module: 'HMS' }
      ); 
    this.$fullscreenLoading();
    this.refreshClicked();
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

@media print,
screen and (min-width: 1290px) {
  .turnaround-analysis-main {
    display: flex;
    padding: 5px 45px;
    width: 100%;
    height: 100%;
    font-size: 12px;
    overflow-x: hidden;

    >.left-container {
      height: 100%;
      min-width: 250px;
      max-width: 250px;
      background-color: white;
      border-radius: 5px;
      margin-right: 5px;
      position: relative;
      overflow: hidden;

      >.button-section {
        display: flex;
        align-items: start;
        justify-content: start;
        width: 100%;

        >button {
          margin-left: 5px;
          font-size: 11px;
        }

        >img {
          height: 20px;
          cursor: pointer;
          justify-self: flex-end;
        }
      }

      >.date-section {
        height: 80px;
        display: flex;
        align-items: center;
        padding: 10px 5px 0 5px;
      }

      >.filter-table {
        width: 100%;
        height: calc(100% - 125px);
        flex-grow: 1;

        >.destcode-filter {
          width: 100%;
          height: calc(100% - 67%);
          padding: 5px 5px 0 5px;
        }
      }
    }

    >.right-container {
      width: 100%;
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;

      >.filtered-section {
        width: 100%;
        height: auto;
        background-color: white;
        border-radius: 5px;
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        z-index: 8;
        display: flex;
        align-items: center;
        margin-bottom: 3px;
        overflow-x: auto;
        overflow-y: hidden;

        >.filtered-items {
          width: calc(100% - 250px);

          >.filtered-row {
            display: flex;
            align-items: center;

            >.filter-title-long {
              width: 270px;
              padding-left: 3px;
            }

            >.filter-title {
              width: 120px;
              padding-left: 3px;
            }

            >.colon-separator {
              margin: 0 5px;
            }

            >.filter-details {
              width: 100%;
            }
          }
        }

        >.refresh-section {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          white-space: nowrap;
          margin-right: 3px;
        }
      }

      >.chart-section {
        height: calc(100% - 40px);
        background: white;

        >.chart-row {
          margin: 4px;
          // background: white;
          border-radius: 5px;
          width: 100%;

          >.chart-row-title {
            font-weight: bolder;
            font-size: medium;
            background: white;
            border-radius: 5px;
          }
          .TAchart {
                      margin: 10px;
                      }
                      
          >.chart-container {
            
            display: flex;
            height: 450px;
            width: 100%;
          

            
            >.col-left{
                width: 50%;
            >.TA-BarChart {
              width: 100%;
              
              >.chart-Container{
                width: 100%;
              }
              >.chart-Title {
                height: auto;
                width: calc(100% - 10px);
                margin-left: 10px;
                font-size: 15px;
                color: black;
                font-weight: bold;

                >.interactable-chart-indicator {
                  height: 22px;
                  width: 22px;
                  top: 3px;
                  right: 3px;
                }
              }
            }
            >.col-bot{
              display: flex;
              justify-content: space-around;
              >.botItem{
                width: 50%;
                height: 100%;
              }
            >.TA-PieChart {
              // width: 30%;
              // height: 50%;
              size: 500px;
              >.chart-Title {
                height: auto;
                width: calc(100% - 10px);
                margin-left: 10px;
                font-size: 15px;
                color: black;
                font-weight: bold;

                >.interactable-chart-indicator {
                  height: 22px;
                  width: 22px;
                  top: 3px;
                  right: 3px;
                }
              }
            }

            .TA-StatsTable {
              // width: 20%;
              // height: 50%;
              height: 100%;

              >.TA-table{
              background-color: white;
               border-radius: 5px;
               height: calc(100% - 60%);
               width: 100%;
               padding-top: 5px;
               color: black;
               font-size: 12px;
               font-family: Oxigen, Helvetica, Arial; 
               margin-top: 3px;



               >.details-table {
                width: 100%;
                border: 1px solid black;
                margin: 10px;

               }
              }

              table, td, th {
              border: 1px solid black;
              min-width: 70px;
              margin-left: 100px;
              font-size: 13px;
              }

              tbody tr:nth-child(1) th:nth-child(1){
                background-color: #ffd246;
              }
              tbody tr:nth-child(2) th:nth-child(1){
                background-color: #28b4c8;
              }
              tbody tr:nth-child(3) th:nth-child(1){
                background-color: #49ff2f;
              }
              tbody tr:nth-child(4) th:nth-child(1){
                background-color: #ff6358;
              }
              tbody tr:nth-child(5) th:nth-child(1){
                background-color: #b773f5;
              }
              
              >.chart-Title {
                height: auto;
                width: calc(100% - 10px);
                margin-left: 100px;
                font-size: 15px;
                color: black;
                font-weight: bold;

                >.interactable-chart-indicator {
                  height: 22px;
                  width: 22px;
                  top: 3px;
                  right: 3px;
                }
              }

             
          }
        }
          }

          >.col-right {
            width: 100%;
            justify-content: center;
            display: flex;
            
            >.TA-GeoMap {
              width:100%;
              >.chart-Title {
                height: auto;
                width: calc(100% - 10px);
                margin-left: 100px;
                font-size: 15px;
                color: black;
                font-weight: bold;
                >.interactable-chart-indicator {
                  height: 22px;
                  width: 22px;
                  top: 3px;
                  right: 3px;
                }
              }
              >.chart-Container{
                >.mapItem{
                    margin: 7px;
                    left:100px
                  }
                >.Item1{
                  width: 700px;
                }
              }


            }
          }
        
          }
        }
      }



      // CSS for section loaders for section loading
      .section-loader {
        width: 100%;
        height: 100%;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #0004;
        z-index: 1000;

        >.section-loader-text {
          width: auto;
          height: 30px;
          padding: 10px;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #ffffff;
          border-radius: 5px;
          box-shadow: 0 0 8px #0004;
          user-select: none;
        }
      }
    }
  }

}

@media print,
screen and (max-width: 1290px) {
  .turnaround-analysis-main {
    display: flex;
    padding: 5px 45px;
    width: 100%;
    height: 100%;
    font-size: 12px;
    overflow-x: hidden;

    >.left-container {
      height: 100%;
      min-width: 300px;
      max-width: 300px;
      background-color: white;
      border-radius: 5px;
      margin-right: 5px;
      position: relative;
      overflow: hidden;

      >.date-section {
        height: 80px;
        display: flex;
        align-items: center;
        padding: 10px 5px 0 5px;
      }

      >.filter-table {
        width: 100%;
        height: calc(100% - 125px);
        flex-grow: 1;

        >.destcode-filter {
          width: 100%;
          height: calc(100% - 67%);
          padding: 5px 5px 0 5px;
        }
      }
    }

    >.right-container {
      width: 100%;
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;

      >.filtered-section {
        width: 100%;
        height: auto;
        background-color: white;
        border-radius: 5px;
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        z-index: 8;
        display: flex;
        align-items: center;
        margin-bottom: 3px;
        overflow-x: auto;
        overflow-y: hidden;

        >.filtered-items {
          width: calc(100% - 250px);

          >.filtered-row {
            display: flex;
            align-items: center;

            >.filter-title-long {
              width: 270px;
              padding-left: 3px;
            }

            >.filter-title {
              width: 120px;
              padding-left: 3px;
            }

            >.colon-separator {
              margin: 0 5px;
            }

            >.filter-details {
              width: 100%;
            }
          }
        }

        >.refresh-section {
          height: 100%;
          min-width: 250px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          white-space: nowrap;
          margin-right: 3px;
        }
      }
      >.chart-section {
        height: calc(100% - 40px);
        background: white;

        >.chart-row {
          margin: 4px;
          // background: white;
          border-radius: 5px;
          width: 100%;

          >.chart-row-title {
            font-weight: bolder;
            font-size: medium;
            background: white;
            border-radius: 5px;
          }
          .TAchart {
            margin: 10px;
          }
                      
          >.chart-container {
            
            display: flex;
            height: 450px;
            width: 100%;
          

            
            >.col-left{
                width: 50%;
            >.TA-BarChart {
              width: 100%;
              
              >.chart-Container{
                width: 100%;
              }
              >.chart-Title {
                height: auto;
                width: calc(100% - 10px);
                margin-left: 10px;
                font-size: 12px;
                color: black;
                font-weight: bold;

                >.interactable-chart-indicator {
                  height: 22px;
                  width: 22px;
                  top: 3px;
                  right: 3px;
                }
              }
            }
            >.col-bot{
              display: flex;
              justify-content: space-around;
              >.botItem{
                width: 50%;
                height: 100%;
              }
            >.TA-PieChart {
              // width: 30%;
              // height: 50%;
              
              >.chart-Title {
                height: auto;
                width: calc(100% - 10px);
                margin-left: 10px;
                font-size: 12px;
                color: black;
                font-weight: bold;

                >.interactable-chart-indicator {
                  height: 22px;
                  width: 22px;
                  top: 3px;
                  right: 3px;
                }
              }
            }

            .TA-StatsTable {
              // width: 20%;
              // height: 50%;
              height: 100%;

              >.TA-table{
              background-color: white;
               border-radius: 5px;
               height: calc(100% - 60%);
               width: 100%;
               padding-top: 5px;
               color: black;
               font-size: 12px;
               font-family: Oxigen, Helvetica, Arial; 
               margin-top: 3px;

               >.details-table {
                width: 100%;
                border: 1px solid black;
                margin: 10px;
               }
              }

              table, td, th {
              border: 1px solid black;
              min-width: 70px;
              }

              tbody tr:nth-child(1) th:nth-child(1){
                background-color: #ffd246;
              }
              tbody tr:nth-child(2) th:nth-child(1){
                background-color: #28b4c8;
              }
              tbody tr:nth-child(3) th:nth-child(1){
                background-color: #49ff2f;
              }
              tbody tr:nth-child(4) th:nth-child(1){
                background-color: #ff6358;
              }
              tbody tr:nth-child(5) th:nth-child(1){
                background-color: #b773f5;
              }
              
              >.chart-Title {
                height: auto;
                width: calc(100% - 10px);
                margin-left: 10px;
                font-size: 12px;
                color: black;
                font-weight: bold;

                >.interactable-chart-indicator {
                  height: 22px;
                  width: 22px;
                  top: 3px;
                  right: 3px;
                }
              }

             
          }
        }
          }

          >.col-right {
            width: 100%;
            justify-content: center;
            display: flex;
            
            >.TA-GeoMap {
              width:100%;
              >.chart-Title {
                height: auto;
                width: calc(100% - 10px);
                left: 100px;
                font-size: 12px;
                color: black;
                font-weight: bold;
                >.interactable-chart-indicator {
                  height: 22px;
                  width: 22px;
                  top: 3px;
                  right: 3px;
                }
              }
              >.chart-Container{
                >.mapItem{
                    margin: 7px;
                  }
                >.Item1{
                  width: 600px;
                }
              }


            }
          }
        
          }
        }
      }



      // CSS for section loaders for section loading
      .section-loader {
        width: 100%;
        height: 100%;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #0004;
        z-index: 1000;

        >.section-loader-text {
          width: auto;
          height: 30px;
          padding: 10px;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #ffffff;
          border-radius: 5px;
          box-shadow: 0 0 8px #0004;
          user-select: none;
        }
      }
    }
  }

}
    
</style>

